export default class HubSettings {
    public url: string;
    constructor(settings: any) {
        this.url = settings.url;
    }
}